import React, { Component, ErrorInfo, ReactNode } from 'react';



class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error Capturado:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload(); // Recarga la página
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <h2>Ocurrió un error 😵</h2>
          <button onClick={this.handleReload}>Reiniciar Aplicación</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
